(function () {
  "use strict";

  if (!document.getElementById("eneto-low-stock-pulse-style")) {
    const style = document.createElement("style");
    style.id = "eneto-low-stock-pulse-style";
    style.textContent = `
      @keyframes eneto-pulse-dot {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.25; }
      }
      .eneto-low-stock-dot {
        display: inline-block;
        animation: eneto-pulse-dot 1.3s ease-in-out infinite;
      }
    `;
    document.head.appendChild(style);
  }

  function initEnetoStandalone() {
    const productSection = document.querySelector(".eneto-step2-grid.eneto-standalone");
    if (!productSection || productSection.dataset.initialized === "true") return;
    productSection.dataset.initialized = "true";

    if (!window.enetoProductData || !Array.isArray(window.enetoProductData.variants)) return;

    const {
      variants,
      currency,
      selectedVariant,
      mediaImages,
      options,
      deliveryTime
    } = window.enetoProductData;

    const curr = currency || "EUR";
    const money = (cents) =>
      new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: curr
      }).format((cents || 0) / 100);

    function formatDiff(diffCents) {
  const euros = Math.round(diffCents / 100);
  if (euros === 0) return "";
  if (euros > 0) {
    return `<span class="eneto-variant-price-diff--positive">+${euros}€</span>`;
  } else {
    return `<span class="eneto-variant-price-diff--negative">–${Math.abs(euros)}€</span>`;
  }
}

    function calculatePriceDiff(baseVariantId, testVariantId) {
      const base = variants.find((v) => v.id == baseVariantId);
      const test = variants.find((v) => v.id == testVariantId);
      if (!base || !test) return 0;
      return test.price - base.price;
    }

    function updateOptionPriceDiffs(optionIndex, selectedOptions, baseVariantId) {
      if (typeof optionIndex !== "number" || !baseVariantId) return;
      const buttons = document.querySelectorAll(
        `.eneto-variants__group[data-option-index="${optionIndex}"] .eneto-variant-btn`
      );
      if (!buttons.length) return;
      buttons.forEach((btn) => {
        const diffSpan = btn.querySelector(".eneto-variant-price-diff");
        if (!diffSpan) return;
        const newValue = btn.dataset.optionValue;
        const tempOptions = [...selectedOptions];
        tempOptions[optionIndex] = newValue;
        const candidate = variants.find((v) => {
          const opts =
            Array.isArray(v.options) && v.options.length > 0 && v.options[0] != null
              ? v.options
              : [v.option1, v.option2, v.option3].filter(Boolean);
          return (
            opts.length === tempOptions.length &&
            opts.every((opt, i) => opt === tempOptions[i])
          );
        });
        if (!candidate) { diffSpan.textContent = ""; return; }
        const diff = calculatePriceDiff(baseVariantId, candidate.id);
        diffSpan.innerHTML = formatDiff(diff);
      });
    }

    // ── GALLERY ──────────────────────────────────────────────────
    const mainImg = document.getElementById("eneto-step1-mainimg");
    const thumbsRoot = document.getElementById("eneto-thumbs");
    const prevBtn = document.getElementById("eneto-gallery-prev");
    const nextBtn = document.getElementById("eneto-gallery-next");
    const images = Array.isArray(mediaImages) ? mediaImages : [];
    let currentIndex = 0;

    function renderThumbs() {
      if (!thumbsRoot) return;
      thumbsRoot.innerHTML = "";
      images.forEach((img, i) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "eneto-thumb-btn";
        btn.dataset.index = String(i);
        btn.innerHTML = `<img src="${img.thumb}" alt="${img.alt || ""}">`;
        btn.addEventListener("click", () => { showImage(i); });
        thumbsRoot.appendChild(btn);
      });
      const multi = images.length > 1;
      if (prevBtn) prevBtn.hidden = !multi;
      if (nextBtn) nextBtn.hidden = !multi;
    }

    function updateThumbActive(index) {
      if (!thumbsRoot) return;
      thumbsRoot.querySelectorAll(".eneto-thumb-btn").forEach((b) => b.classList.remove("is-active"));
      const active = thumbsRoot.querySelector(`.eneto-thumb-btn[data-index="${index}"]`);
      if (active) active.classList.add("is-active");
    }

    function showImage(index) {
      if (!images.length || !mainImg) return;
      currentIndex = (index + images.length) % images.length;
      const img = images[currentIndex];
      mainImg.src = img.src;
      mainImg.alt = img.alt || "";
      mainImg.removeAttribute("srcset");
      updateThumbActive(currentIndex);
    }

    function showImageById(mediaId) {
      const index = images.findIndex((img) => img.id === mediaId);
      if (index > -1) showImage(index);
    }

    function initGallery() {
      if (!mainImg) return;
      renderThumbs();
      if (images.length) {
        const initialVariant = findVariant();
        if (initialVariant?.featured_image?.id) {
          showImageById(initialVariant.featured_image.id);
        } else {
          showImage(0);
        }
      }
      if (prevBtn) prevBtn.addEventListener("click", () => {
        showImage(currentIndex - 1);
        prevBtn.classList.add("is-clicked");
        setTimeout(() => prevBtn.classList.remove("is-clicked"), 150);
      });
      if (nextBtn) nextBtn.addEventListener("click", () => {
        showImage(currentIndex + 1);
        nextBtn.classList.add("is-clicked");
        setTimeout(() => nextBtn.classList.remove("is-clicked"), 150);
      });

      // Inline style für Klick-Feedback (kein externes CSS nötig)
      const galleryStyle = document.createElement("style");
      galleryStyle.textContent = `
        .eneto-gallery-nav.is-clicked {
          transform: translateY(-50%) scale(0.88) !important;
          background: #fff !important;
          box-shadow: 0 0 0 2px rgba(0,0,0,0.12) !important;
          transition: transform 0.1s ease, box-shadow 0.1s ease;
        }
      `;
      document.head.appendChild(galleryStyle);
    }

    // ── VARIANTS ─────────────────────────────────────────────────
    const priceCurrentEl = document.getElementById("eneto-price-current");
    const priceCompareEl = document.getElementById("eneto-price-compare");
    const root = document.getElementById("eneto-variants-root");
    const idInput = document.getElementById("SelectedVariantId");

    const normalizeOptions = (v) =>
      v
        ? Array.isArray(v.options) && v.options.length > 0 && v.options[0] != null
          ? v.options
          : [v.option1, v.option2, v.option3].filter(Boolean)
        : [];

    let selectedOptions = normalizeOptions(selectedVariant);

    const findVariant = () =>
      variants.find((v) => {
        const opts = normalizeOptions(v);
        return opts.length === selectedOptions.length && opts.every((opt, i) => opt === selectedOptions[i]);
      });

    function updateTotalPrice() {
      const mainPrice = parseInt(idInput?.dataset.price || "0", 10);
      const mainComparePrice = parseInt(idInput?.dataset.comparePrice || "0", 10);
      if (priceCurrentEl) {
        priceCurrentEl.textContent = money(mainPrice);
        priceCurrentEl.classList.toggle("eneto-price__current--discounted", mainComparePrice > mainPrice);
      }
      if (priceCompareEl) {
        if (mainComparePrice > mainPrice) {
          priceCompareEl.textContent = money(mainComparePrice);
          priceCompareEl.hidden = false;
        } else {
          priceCompareEl.textContent = "";
          priceCompareEl.hidden = true;
        }
      }
    }

    function renderByVariant(variant) {
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      idInput.dataset.price = variant.price;
      idInput.dataset.comparePrice = variant.compare_at_price || variant.price;
      const deliveryEl = document.getElementById("eneto-delivery-container");
      const atcBtn = document.getElementById("eneto-add-to-cart");
      updateTotalPrice();
      if (deliveryEl && atcBtn) {
        if (variant.available) {
          const deliveryTimeHTML = deliveryTime ? `<span class="delivery-time">${deliveryTime}</span>` : "";
          deliveryEl.innerHTML = `<div style="color: #F97316;"><span class="eneto-low-stock-dot">●</span> Schnell vergriffen ${deliveryTimeHTML}</div>`;
          atcBtn.disabled = false;
          atcBtn.textContent = "In den Warenkorb";
        } else {
          deliveryEl.innerHTML = '<div><span style="color: var(--eneto-out-of-stock);">●</span> Ausverkauft</div>';
          atcBtn.disabled = true;
          atcBtn.textContent = "Nicht verfügbar";
        }
      }
      if (variant.featured_image && variant.featured_image.id) {
        showImageById(variant.featured_image.id);
      }
    }

    function updateUI() {
      const currentVariant = findVariant();
      if (currentVariant) {
        renderByVariant(currentVariant);
        const url = new URL(window.location.href);
        url.searchParams.set("variant", currentVariant.id);
        window.history.replaceState({}, "", url);
      }

      if (root) {
        root.querySelectorAll(".eneto-variants__group").forEach((group) => {
          const optionIndex = parseInt(group.dataset.optionIndex, 10);
          const display = group.querySelector(".selected-option-display");
          if (display) display.textContent = selectedOptions[optionIndex] ?? "";
          group.querySelectorAll(".eneto-variant-btn").forEach((btn) => {
            const value = btn.dataset.optionValue;
            btn.setAttribute("aria-pressed", String(value === selectedOptions[optionIndex]));
            const tempOptions = [...selectedOptions];
            tempOptions[optionIndex] = value;
            const isAvailable = variants.some((v) => {
              const vOpts = normalizeOptions(v);
              return (
                vOpts.length === tempOptions.length &&
                v.available &&
                vOpts.every((opt, idx) => opt === tempOptions[idx])
              );
            });
            btn.disabled = !isAvailable;
          });
        });
      }

      if (root) {
        const baseId = findVariant()?.id || idInput?.value;
        if (baseId) {
          root.querySelectorAll(".eneto-variants__group").forEach((group) => {
            const idx = parseInt(group.dataset.optionIndex, 10);
            updateOptionPriceDiffs(idx, selectedOptions, baseId);
          });
        }
      }
    }

    function setupVariants() {
      if (!root) { renderByVariant(findVariant()); return; }
      root.addEventListener("click", (e) => {
        const btn = e.target.closest(".eneto-variant-btn");
        if (!btn || btn.disabled) return;
        const group = btn.closest(".eneto-variants__group");
        const optionIndex = parseInt(group.dataset.optionIndex, 10);
        selectedOptions[optionIndex] = btn.dataset.optionValue;

        if (!findVariant()) {
          const possibleVariants = variants.filter((v) => {
            const vOpts = normalizeOptions(v);
            return v.available && vOpts[optionIndex] === selectedOptions[optionIndex];
          });
          if (possibleVariants.length > 0) selectedOptions = normalizeOptions(possibleVariants[0]);
        }
        updateUI();
        // Trigger speicher infobox update
        updateSpeicherBox(btn.dataset.optionValue || btn.querySelector(".eneto-variant-label")?.textContent?.trim());
      });

      updateUI();
    }

    // ── SHIPPING POPUP ───────────────────────────────────────────
    function setupShippingPopup() {
      const trigger = document.getElementById("shipping-cost-trigger");
      const popup = document.getElementById("shipping-cost-popup");
      if (!trigger || !popup) return;
      const closeBtn = popup.querySelector(".popup-close");
      const postcodeIn = document.getElementById("shipping-postcode-input");
      const ui = {
        subtotal: document.getElementById("shipping-subtotal"),
        shippingCost: document.getElementById("shipping-cost-value"),
        total: document.getElementById("shipping-total"),
        deliveryWindow: document.getElementById("shipping-delivery-window"),
        deliveryContainer: document.getElementById("shipping-delivery-container")
      };
      const popupAtcBtn = document.getElementById("popup-add-to-cart-btn");
      const mainForm = document.getElementById("eneto-atc-form");
      const money2 = (cents) =>
        new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format((cents || 0) / 100);

      function computeDeliveryWindow() {
        const now = new Date();
        const cutoff = new Date(now);
        cutoff.setHours(14, 0, 0, 0);
        const isWeekend = (d) => [0, 6].includes(d.getDay());
        const addBusinessDays = (date, days) => {
          const d = new Date(date);
          let added = 0;
          while (added < days) { d.setDate(d.getDate() + 1); if (!isWeekend(d)) added++; }
          return d;
        };
        const handlingOffset = now <= cutoff && !isWeekend(now) ? 0 : 1;
        const start = addBusinessDays(now, handlingOffset + 1);
        const end = addBusinessDays(now, handlingOffset + 3);
        const fmt = new Intl.DateTimeFormat("de-DE", { weekday: "short", day: "numeric", month: "short" });
        return `${fmt.format(start)} – ${fmt.format(end)}`;
      }

      function renderView(calculateShipping = false) {
        const subtotalCents = parseInt(idInput?.dataset.price || "0", 10);
        ui.subtotal.textContent = money2(subtotalCents);
        if (calculateShipping) {
          const postcode = postcodeIn.value.trim();
          let shippingCents = 3900;
          const highCostPrefixes = [
            "18565","25849","25859","25863","25869","25938","25946","25980",
            "25992","25996","25997","25999","26465","26474","26486","26548",
            "26571","26579","26757","27498"
          ];
          if (postcode.length === 5 && highCostPrefixes.includes(postcode)) shippingCents = 5900;
          ui.shippingCost.textContent = money2(shippingCents);
          ui.total.textContent = money2(subtotalCents + shippingCents);
          ui.deliveryWindow.textContent = computeDeliveryWindow();
          ui.deliveryContainer.style.display = "block";
        } else {
          ui.shippingCost.textContent = "--,-- €";
          ui.total.textContent = "--,-- €";
          ui.deliveryContainer.style.display = "none";
          ui.deliveryWindow.textContent = "--";
        }
      }

      const open = () => {
        popup.hidden = false;
        document.documentElement.classList.add("eneto-no-scroll");
        postcodeIn.value = "";
        renderView(false);
      };
      const close = () => {
        popup.hidden = true;
        document.documentElement.classList.remove("eneto-no-scroll");
      };
      postcodeIn.addEventListener("input", () => {
        (/^\d{5}$/).test(postcodeIn.value) ? renderView(true) : renderView(false);
      });
      trigger.addEventListener("click", open);
      closeBtn.addEventListener("click", close);
      popup.addEventListener("click", (e) => { if (e.target === popup) close(); });
      document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !popup.hidden) close(); });
      if (popupAtcBtn) {
        popupAtcBtn.addEventListener("click", () => {
          if (mainForm) mainForm.querySelector("#eneto-add-to-cart").click();
          close();
        });
      }
    }

    // ── CART ─────────────────────────────────────────────────────
    function setupCart() {
      const form = document.getElementById("eneto-atc-form");
      if (!form) return;
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const atcBtn = form.querySelector("#eneto-add-to-cart");
        const originalBtnText = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.setAttribute("aria-busy", "true");
        atcBtn.textContent = "Wird hinzugefügt...";
        try {
          const items = [{ id: document.getElementById("SelectedVariantId").value, quantity: 1 }];
          const formData = new FormData();
          const cartDrawerElement = document.querySelector("cart-drawer");
          const sectionId = cartDrawerElement ? cartDrawerElement.id : "cart-drawer";
          formData.append("sections", sectionId);
          formData.append("sections_url", window.location.pathname);
          items.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
          });
          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: "POST",
            body: formData,
            headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" }
          });
          if (!response.ok) throw new Error(await response.text());
          const cartData = await response.json();
          const drawerHtml = cartData.sections[sectionId];
          if (cartDrawerElement && drawerHtml) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = drawerHtml;
            const newDrawerContent = tempDiv.querySelector("cart-drawer");
            if (newDrawerContent) cartDrawerElement.innerHTML = newDrawerContent.innerHTML;
          }
          const totalQuantity = cartData.items.reduce((sum, item) => sum + item.quantity, 0);
          document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((bubble) => {
            if (bubble) { bubble.textContent = totalQuantity; bubble.hidden = totalQuantity === 0; }
          });
          if (cartDrawerElement) {
            typeof cartDrawerElement.show == "function"
              ? cartDrawerElement.show()
              : cartDrawerElement.classList.add("drawer--open");
          }
        } catch (error) {
          console.error("Fehler beim Hinzufügen zum Warenkorb:", error);
          atcBtn.textContent = "Fehler!";
          setTimeout(() => { atcBtn.textContent = originalBtnText; }, 2500);
        } finally {
          atcBtn.disabled = false;
          atcBtn.removeAttribute("aria-busy");
          if (atcBtn.textContent !== "Fehler!") atcBtn.textContent = originalBtnText;
        }
      });
    }

    initGallery();
    setupVariants();
    setupShippingPopup();
    setupCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initEnetoStandalone);
  } else {
    initEnetoStandalone();
  }
  document.addEventListener("shopify:section:load", initEnetoStandalone);
})();


// ============================================================
//  SPEICHER-INFOBOX LOGIK (Standalone)
//  Identisch mit Baukasten, aber:
//  - Nur Option Index 0 (Speicherkapazität)
//  - Modulanzahl wird aus dem Produkttitel gelesen
//  - Kein Halterungs-Listener
// ============================================================
(function () {

  // ── Hilfsfunktion: Infobox-HTML erzeugen ──────────────────────
  function speicherBox(badge, pct, headline, bullets, upsell, upsellStyle) {
    return '<div class="eneto-speicher-content">'
      + '<span class="eneto-speicher-badge">' + badge + '</span>'
      + '<div class="eneto-progress-bar-wrap"><div class="eneto-progress-bar-fill" style="width:' + pct + '%"></div>'
      + '<span class="eneto-progress-bar-label">' + pct + '%</span></div>'
      + '<h3 style="font-size:14px;font-weight:700;color:#000;margin:6px 0 10px 0;">' + headline + '</h3>'
      + '<div class="eneto-speicher-bullets"><div class="eneto-bullet-grid">'
      + bullets.map(function (b) { return '<div class="eneto-bullet-item">' + b + '</div>'; }).join('')
      + '</div></div>'
      + '<div class="eneto-speicher-upsell"' + (upsellStyle ? ' style="' + upsellStyle + '"' : '') + '>' + upsell + '</div>'
      + '</div>';
  }

  // ── SPEICHER-DATEN (identisch mit Baukasten) ──────────────────
  var SPEICHER = {};

  // ANKER
  SPEICHER.anker = {};
  SPEICHER.anker[2] = {
    '2.7 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~430 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~2,9 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '5.4 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Maximale Nutzung bei 2 Modulen',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~504 € Ersparnis/J.', '✓ Empfehlung für 2-Modul-Anlagen', '✓ ~3,7 J. Amortisation'],
      'Schließe die Lücke: Hol dir die volle Unabhängigkeit mit der nächsten Stufe.'),
    '8.1 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~532 € Ersparnis/J.', '✓ Puffer für bewölkte Tage', '✓ ~4,7 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet noch mehr Puffer.'),
    '10.8 kWh': speicherBox('Smart-Grid Kraftpaket', 100, 'Maximale Reserve bei 2 Modulen',
      ['✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~541 € Ersparnis/J.', '✓ Ideal für Haushalte mit variablem Verbrauch', '✓ ~5,7 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '13.4 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~6,8 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit.'),
    '16.1 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~7,9 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };
  SPEICHER.anker[4] = {
    '2.7 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Einstieg – du verschenkst noch viel',
      ['✓ Deckt erste Grundlast', '✓ ~823 € Ersparnis/J.', '✓ Ausbaubar bis 16,1 kWh', '✓ ~1,8 J. Amortisation'],
      '⚠️ Bei 4 Modulen erzeugst du viel mehr Strom – ein kleiner Speicher verschenkt den Großteil davon ans Netz.'),
    '5.4 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Empfehlung für Standard-Haushalte (4 Module)',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~962 € Ersparnis/J.', '✓ Die Empfehlung für 4-Modul-Anlagen', '✓ ~2,2 J. Amortisation'],
      'Schließe die Lücke: Du verschenkst immer noch wertvolle kWh. Hol dir die volle Unabhängigkeit mit Stufe 3.'),
    '8.1 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote bei 4 Modulen',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~1100 € Ersparnis/J.', '✓ Ideal bei 4 Modulen', '✓ ~2,5 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage und dynamische Tarife.'),
    '10.8 kWh': speicherBox('Smart-Grid Kraftpaket', 100, 'Für 4+ Module & hohen Verbrauch',
      ['✓ Ideal bei 4+ Modulen & hohem Stromverbrauch', '✓ ~1193 € Ersparnis/J.', '✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~2,8 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '13.4 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für moderne Haushalte mit E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~6,8 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '16.1 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~7,9 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };

  // CONOW
  SPEICHER.conow = {};
  SPEICHER.conow[2] = {
    '2.00 kWh': speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~421 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~3,2 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '4.1 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Maximale Nutzung bei 2 Modulen',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~495 € Ersparnis/J.', '✓ Empfehlung für 2-Modul-Anlagen', '✓ ~3,8 J. Amortisation'],
      'Schließe die Lücke: Hol dir die volle Unabhängigkeit mit der nächsten Stufe.'),
    '6.2 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~522 € Ersparnis/J.', '✓ Ideal bei 2 Modulen', '✓ ~4,6 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage und dynamische Tarife.'),
    '8.2 kWh':  speicherBox('Smart-Grid Kraftpaket', 100, 'Maximale Reserve & dynamische Tarife',
      ['✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~532 € Ersparnis/J.', '✓ Ideal für variablen Verbrauch', '✓ ~5,5 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '10.2 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~6,3 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '12.3 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~7,3 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };
  SPEICHER.conow[4] = {
    '2.00 kWh': speicherBox('Grundlast-Optimierung', 65, 'Einstieg – du verschenkst noch viel',
      ['✓ Deckt erste Grundlast', '✓ ~380 € Ersparnis/J.', '✓ Ausbaubar bis 12,3 kWh', '✓ ~3,2 J. Amortisation'],
      '⚠️ Bei 4 Modulen erzeugst du viel mehr Strom – ein kleiner Speicher verschenkt den Großteil davon ans Netz.'),
    '4.1 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Empfehlung für Standard-Haushalte (4 Module)',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~495 € Ersparnis/J.', '✓ Die Empfehlung für 4-Modul-Anlagen', '✓ ~3,8 J. Amortisation'],
      'Schließe die Lücke: Du verschenkst immer noch wertvolle kWh. Hol dir die volle Unabhängigkeit.'),
    '6.2 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote bei 4 Modulen',
      ['✓ Fast 0 € Verschenkt', '✓ ~522 € Ersparnis/J.', '✓ Ideal bei 4 Modulen', '✓ ~4,6 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '8.2 kWh':  speicherBox('Smart-Grid Kraftpaket', 100, 'Für 4+ Module & hohen Verbrauch',
      ['✓ Ideal bei 4+ Modulen & hohem Stromverbrauch', '✓ ~532 € Ersparnis/J.', '✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~5,5 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '10.2 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für moderne Haushalte mit E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~6,3 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '12.3 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~7,3 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };

  // MARSTEK Venus A
  SPEICHER.marstek = {};
  SPEICHER.marstek[2] = {
    '2.1 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~421 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~2,0 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '4.2 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Maximale Nutzung bei 2 Modulen',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~495 € Ersparnis/J.', '✓ Empfehlung für 2-Modul-Anlagen', '✓ ~2,8 J. Amortisation'],
      'Schließe die Lücke: Hol dir die volle Unabhängigkeit mit der nächsten Stufe.'),
    '6.4 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~522 € Ersparnis/J.', '✓ Ideal bei 2 Modulen', '✓ ~3,7 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '8.5 kWh':  speicherBox('Smart-Grid Kraftpaket', 100, 'Maximale Reserve & dynamische Tarife',
      ['✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~532 € Ersparnis/J.', '✓ Ideal für variablen Verbrauch', '✓ ~4,6 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität.'),
    '10.6 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~5,5 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit.'),
    '12.7 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~6,5 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };
  SPEICHER.marstek[4] = {
    '2.1 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Einstieg – du verschenkst noch viel',
      ['✓ Deckt erste Grundlast', '✓ ~805 € Ersparnis/J.', '✓ Ausbaubar bis 12,7 kWh', '✓ ~1,4 J. Amortisation'],
      '⚠️ Bei 4 Modulen erzeugst du viel mehr Strom – ein kleiner Speicher verschenkt den Großteil davon ans Netz.'),
    '4.2 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Empfehlung für Standard-Haushalte (4 Module)',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~934 € Ersparnis/J.', '✓ Die Empfehlung für 4-Modul-Anlagen', '✓ ~1,7 J. Amortisation'],
      'Schließe die Lücke: Du verschenkst immer noch wertvolle kWh. Hol dir die volle Unabhängigkeit.'),
    '6.4 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote bei 4 Modulen',
      ['✓ Fast 0 € Verschenkt', '✓ ~1054 € Ersparnis/J.', '✓ Ideal bei 4 Modulen', '✓ ~2,0 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '8.5 kWh':  speicherBox('Smart-Grid Kraftpaket', 100, 'Für 4+ Module & hohen Verbrauch',
      ['✓ Ideal bei 4+ Modulen & hohem Stromverbrauch', '✓ ~1147 € Ersparnis/J.', '✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~2,3 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '10.6 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für moderne Haushalte mit E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~5,5 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '12.7 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~6,5 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };

  // MARSTEK Venus E / AC
  SPEICHER.marstekAC = {};
  SPEICHER.marstekAC[2] = {
    '5.1 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~458 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~3,1 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '10.2 kWh': speicherBox('Volle Kapazität', 98, 'Maximale Nutzung deiner Solaranlage',
      ['✓ Optimale Eigenverbrauchsquote', '✓ ~532 € Ersparnis/J.', '✓ Ideal für größere Haushalte', '✓ ~4,8 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig.')
  };
  SPEICHER.marstekAC[4] = {
    '5.1 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~869 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~1,9 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '10.2 kWh': speicherBox('Volle Kapazität', 98, 'Maximale Nutzung deiner Solaranlage',
      ['✓ Optimale Eigenverbrauchsquote', '✓ ~1100 € Ersparnis/J.', '✓ Ideal für größere Haushalte', '✓ ~2,5 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig.')
  };

  // JACKERY
  SPEICHER.jackery = {};
  SPEICHER.jackery[2] = {
    '2.5 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~430 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~3,4 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '5.0 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Maximale Nutzung bei 2 Modulen',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~504 € Ersparnis/J.', '✓ Empfehlung für 2-Modul-Anlagen', '✓ ~4,3 J. Amortisation'],
      'Schließe die Lücke: Hol dir die volle Unabhängigkeit mit der nächsten Stufe.'),
    '7.5 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~532 € Ersparnis/J.', '✓ Ideal bei 2 Modulen', '✓ ~5,4 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '10.0 kWh': speicherBox('Smart-Grid Kraftpaket', 100, 'Maximale Reserve & dynamische Tarife',
      ['✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~541 € Ersparnis/J.', '✓ Ideal für variablen Verbrauch', '✓ ~6,6 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität.'),
    '12.5 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~7,7 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit.'),
    '15.0 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~9,0 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };
  SPEICHER.jackery[4] = {
    '2.5 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Einstieg – du verschenkst noch viel',
      ['✓ Deckt erste Grundlast', '✓ ~823 € Ersparnis/J.', '✓ Ausbaubar bis 15,1 kWh', '✓ ~2,1 J. Amortisation'],
      '⚠️ Bei 4 Modulen erzeugst du viel mehr Strom – ein kleiner Speicher verschenkt den Großteil davon ans Netz.'),
    '5.0 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Empfehlung für Standard-Haushalte (4 Module)',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~962 € Ersparnis/J.', '✓ Die Empfehlung für 4-Modul-Anlagen', '✓ ~2,5 J. Amortisation'],
      'Schließe die Lücke: Du verschenkst immer noch wertvolle kWh. Hol dir die volle Unabhängigkeit.'),
    '7.5 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote bei 4 Modulen',
      ['✓ Fast 0 € Verschenkt', '✓ ~1100 € Ersparnis/J.', '✓ Ideal bei 4 Modulen', '✓ ~2,8 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '10.0 kWh': speicherBox('Smart-Grid Kraftpaket', 100, 'Für 4+ Module & hohen Verbrauch',
      ['✓ Ideal bei 4+ Modulen & hohem Stromverbrauch', '✓ ~1211 € Ersparnis/J.', '✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~3,1 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '12.5 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für moderne Haushalte mit E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~7,7 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '15.0 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~9,0 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };

  // ── Farb-Maps ─────────────────────────────────────────────────
  var COLOR_MAPS = {
    anker:     { '2.7 kWh':'yellow',  '5.4 kWh':'green',  '8.1 kWh':'blue',  '10.8 kWh':'purple', '13.4 kWh':'purple', '16.1 kWh':'purple' },
    conow:     { '2.00 kWh':'yellow', '4.1 kWh':'green',  '6.2 kWh':'blue',  '8.2 kWh':'purple',  '10.2 kWh':'purple', '12.3 kWh':'purple' },
    marstek:   { '2.1 kWh':'yellow',  '4.2 kWh':'green',  '6.4 kWh':'blue',  '8.5 kWh':'purple',  '10.6 kWh':'purple', '12.7 kWh':'purple' },
    marstekAC: { '5.1 kWh':'yellow',  '10.2 kWh':'green' },
    jackery:   { '2.5 kWh':'yellow',  '5.0 kWh':'green',  '7.6 kWh':'blue',  '10.1 kWh':'purple', '12.6 kWh':'purple', '15.1 kWh':'purple' }
  };

  // ── Produkterkennung ──────────────────────────────────────────
  function getSpeicherConfig() {
    var title = (
      (window.enetoProductData && window.enetoProductData.title) || document.title
    ).toLowerCase();

    var modules = (window.enetoProductData && window.enetoProductData.moduleCount)
      ? parseInt(window.enetoProductData.moduleCount, 10)
      : 2;

    if (title.includes('anker')) {
      return { data: SPEICHER.anker[modules] || SPEICHER.anker[2], colors: COLOR_MAPS.anker };
    }
    if (title.includes('conow') || title.includes('cbe')) {
      return { data: SPEICHER.conow[modules] || SPEICHER.conow[2], colors: COLOR_MAPS.conow };
    }
    if (title.includes('venus e') || title.includes('ac speicher')) {
      return { data: SPEICHER.marstekAC[modules] || SPEICHER.marstekAC[2], colors: COLOR_MAPS.marstekAC };
    }
    if (title.includes('marstek') || title.includes('venus')) {
      return { data: SPEICHER.marstek[modules] || SPEICHER.marstek[2], colors: COLOR_MAPS.marstek };
    }
    if (title.includes('jackery')) {
      return { data: SPEICHER.jackery[modules] || SPEICHER.jackery[2], colors: COLOR_MAPS.jackery };
    }
    return { data: SPEICHER.marstek[2], colors: COLOR_MAPS.marstek };
  }

  // ── Box aktualisieren ─────────────────────────────────────────
  function updateBox(boxId, data, color, selectedValue) {
    var box = document.getElementById(boxId);
    if (!box) return;
    box.classList.remove(
      'eneto-halterung-infobox--green', 'eneto-halterung-infobox--gray',
      'eneto-halterung-infobox--red',   'eneto-halterung-infobox--yellow',
      'eneto-halterung-infobox--blue',  'eneto-halterung-infobox--purple'
    );
    box.classList.add('eneto-halterung-infobox--' + color);
    var text = data ? data[selectedValue] : null;
    if (text) {
      box.innerHTML = text;
      box.classList.add('is-visible');
    } else {
      box.innerHTML = '';
      box.classList.remove('is-visible');
    }
    var footnote = document.getElementById('eneto-speicher-footnote');
    if (footnote) footnote.hidden = !text;
  }

  // ── Globale Funktion für Variant-Click-Handler oben ──────────
  window.updateSpeicherBox = function (value) {
    if (!value) return;
    var cfg = getSpeicherConfig();
    updateBox('eneto-speicher-infobox', cfg.data, cfg.colors[value] || 'green', value);
  };

  // ── Initialisierung ───────────────────────────────────────────
  function attachListeners() {
    var cfg = getSpeicherConfig();
    var speicherData     = cfg.data;
    var speicherColorMap = cfg.colors;

    var speicherGroup = document.querySelector('.eneto-standalone .eneto-variants__group[data-option-index="0"]');
    if (!speicherGroup) return;

    speicherGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('.eneto-variant-btn');
      if (!btn) return;
      var value = btn.getAttribute('data-option-value') ||
        (btn.querySelector('.eneto-variant-label') && btn.querySelector('.eneto-variant-label').textContent.trim());
      if (value) updateBox('eneto-speicher-infobox', speicherData, speicherColorMap[value] || 'green', value);
    });

    var activeBtn = speicherGroup.querySelector('.eneto-variant-btn[aria-pressed="true"]');
    if (activeBtn) {
      var initVal = activeBtn.getAttribute('data-option-value') ||
        (activeBtn.querySelector('.eneto-variant-label') && activeBtn.querySelector('.eneto-variant-label').textContent.trim());
      if (initVal) updateBox('eneto-speicher-infobox', speicherData, speicherColorMap[initVal] || 'green', initVal);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }
  document.addEventListener('shopify:section:load', attachListeners);
})();
